import React from "react";
import { useQuery } from "@apollo/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretRight } from "@fortawesome/free-solid-svg-icons";

import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";
import { GET_GROUPED_SAMPLING_STATIONS } from "../../../queries/archiveQrys/InventoryReportQueries";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const GroupedSamplingStationTable = (props) => {
  const { systemId } = props;

  const columns = [
    {
      Header: () => <span className="visually-hidden">Expand Row</span>,
      id: "expander",
      width: 30,
      Cell: ({ row }) => (
        <button
          type="button"
          {...row.getToggleRowExpandedProps()}
          aria-label={row.isExpanded ? "Collapse row" : "Expand row"}
          style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
        >
          {row.isExpanded ? (
            <FontAwesomeIcon className='font-icon' icon={faCaretDown} cypressid={row.original.groupId + "_gssd"} />
          ) : (
            <FontAwesomeIcon className='font-icon' icon={faCaretRight} cypressid={row.original.groupId + "_gssr"} />
          )}
          <span className="visually-hidden">{row.isExpanded ? "Collapse row" : "Expand row"}</span>
        </button>
      )
    },
    {
      Header: "Sample Group ID",
      accessor: "groupId",
      width: 75
    },
    {
      Header: "Sample Group",
      accessor: "groupName",
      width: 200
    }
  ];

  const details = React.useMemo(
    () => [
      {
        Header: "Source ID",
        accessor: "sourceId",
        width: 50
      },
      {
        Header: "Source Name",
        accessor: "sourceName",
        width: 125
      },
      {
        Header: "Sample Group Details",
        accessor: "groupDetails",
        width: 100
      },
      {
        Header: "System",
        accessor: (d) => {
          return d.systemNumber + " " + d.systemName;
        },
        width: 200
      }
    ],
    []
  );

  const { loading, error, data } = useQuery(GET_GROUPED_SAMPLING_STATIONS, {
    variables: { systemId }
  });

  const subTable = React.useCallback(
    ({ row }) =>
      row.original.groupDetails.length > 0 ? (
        <DtsReactTable columns={details} data={row.original.groupDetails} headerColor='grey'/>
      ) : (
        "No Data"
      ),
    [details]
  );

  const expandedRows = React.useMemo(() => {
    if (data) {
      let arr;
      let d = data;
      if (d.getGroupedSamplingStationBySystemId.length > 0) {
        arr = d.getGroupedSamplingStationBySystemId.map((sid, ind) => {
          return { [ind]: true };
        });
      }
      return arr;
    }
  }, [data]);

  if (loading) {
    return <SkeletonLoader width='100%'/>;
  }
  if(error) return <ErrorHandler error={error} />

  return (
    <>
      {data.getGroupedSamplingStationBySystemId.length > 0 ? (
        <DtsReactTable
          data={data.getGroupedSamplingStationBySystemId}
          columns={columns}
          headerColor='ddw'
          showPagination={data.getGroupedSamplingStationBySystemId.length > 10}
          renderRowSubComponent={subTable}
          expandRows={true}
          expandedRowObj={expandedRows}
          cypressid="grpSmpStation"
          subTableId='_gssSubTable'
        />
      ) : (
        <span>
          <em>No data was found for grouped sampling stations.</em>
        </span>
      )}
    </>
  );
};

export default GroupedSamplingStationTable;
